module.exports = __webpack_public_path__ + "static/media/wizualizacja-82.0196e491.png";